import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { TiresReplacementsHistory } from 'models/tires-replacements-history';
import { http } from 'services/http';

export const getTiresReplacementsHistoryApi = (params?: string) =>
  http.get<ResponseWithPagination<TiresReplacementsHistory>>(
    `${ApiPath.TIRES_REPLACEMENTS_HISTORY}${params || ''}`
  );
